import React from 'react';
import DatePicker from 'react-datepicker';
import {Form, Select, Input, Button} from 'semantic-ui-react';
import {parseCampaignOptions} from '../../utils';
import {parseDealers} from '../../../common/util/options';
import {dateFormatPicker} from '../../../common/constants/datesFormat';
import {warrantyCampaignsStatus} from '../../constants';

const additionalOptions = [
  {'text': 'TODOS', 'value': 'TODOS'},
  {'text': 'SIN CONCESIONARIO', 'value': 'SIN'},
];

const SearchForm = ({
  disabled,
  status,
  taskId,
  endDate,
  loading,
  startDate,
  campaignNo,
  asignedDealer,
  attendedDealer,
  dealersList,
  campaignList,
  handleClear,
  handleSearch,
  handleChange,
  handleChangeDate,
}) => {
  const dealers = parseDealers(dealersList);
  const dealersOptions = additionalOptions.concat(dealers);
  const dealersOptionsWarranty = [additionalOptions[0]].concat(dealers);
  const campaignOptions = parseCampaignOptions(campaignList);

  return (
    <React.Fragment>
      <Form.Group widths='5'>
        <Form.Field
          name='status'
          label='Estado Campaña'
          placeholder='Seleccione Estado'
          control={Select}
          options={warrantyCampaignsStatus}
          value={status}
          onChange={handleChange}
        />
        <Form.Field
          search
          name='asignedDealer'
          label='Concesionario Asignado'
          placeholder='Seleccione Concesionario'
          control={Select}
          options={dealersOptions}
          value={asignedDealer}
          onChange={handleChange}
        />
        <Form.Field
          search
          value={campaignNo}
          control={Select}
          options={campaignOptions}
          label='Campaña'
          name='campaignNo'
          placeholder='Seleccione Campaña'
          onChange={handleChange}
        />
      </Form.Group>
      <Form.Group widths='5'>
        <Form.Field
          search
          name='attendedDealer'
          label='Concesionario Atendido'
          placeholder='Seleccione Concesionario'
          control={Select}
          options={dealersOptionsWarranty}
          value={attendedDealer}
          onChange={handleChange}
        />
        <Form.Input fluid label='Fecha de inicio'>
          <DatePicker
            placeholderText='Fecha de inicio'
            className='tcc-datepicker'
            showYearDropdown
            selected={startDate}
            dateFormat={dateFormatPicker}
            onChange={(date) => handleChangeDate('startDate', date)}
            locale='es'
          />
        </Form.Input>
        <Form.Input fluid label='Fecha de fin'>
          <DatePicker
            placeholderText='Fecha de fin'
            className='tcc-datepicker'
            showYearDropdown
            selected={endDate}
            dateFormat={dateFormatPicker}
            minDate={startDate}
            onChange={(date) => handleChangeDate('endDate', date)}
            locale='es'
          />
        </Form.Input>
        <Form.Field
          value={taskId}
          control={Input}
          label='Numero de Tarea'
          placeholder='Numero de tarea'
          name='taskId'
          onChange={handleChange}
        />
        <div className='btn-container'>
          <Button
            primary
            loading={loading}
            disabled={disabled}
            onClick={handleSearch}
            type='submit'
          >
            BUSCAR
          </Button>
          <Button
            secondary
            disabled={loading || disabled}
            onClick={handleClear}
          >
            LIMPIAR
          </Button>
        </div>
      </Form.Group>
    </React.Fragment>
  );
};

export default SearchForm;
